import React from 'react';

import useClaimsCardsList from '@/modules/employer/components/Lockbox/LockboxDetails/hooks/useClaimsCardsList';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import ClaimsList from './components/ClaimsList';
import useExtendClaimsWithMatchingData from './hooks/useExtendClaimsWithMatchingData';

const CreatedClaimRepayments = () => {
  const { originalLockbox } = useLockboxDetailsStore();
  const { claimsWithMatchingData, isLoaded } = useExtendClaimsWithMatchingData({ claims: originalLockbox?.createdClaimRepayments });

  const { fields } = useClaimsCardsList({ lockboxClaims: isLoaded ? claimsWithMatchingData : [] });

  if (!claimsWithMatchingData?.length) {
    return null;
  }

  return (
    <ClaimsList
      fields={fields}
    />
  );
};

export default CreatedClaimRepayments;
